// Module-level store for the last-saved project config snapshot.
// Used by the leave guard to detect unsaved changes.
//
// Snapshot writes are not Redux actions, so `store.subscribe` won't see them.
// We expose `subscribeSavedSnapshot` so observers (the leave guard) can also
// re-evaluate after a successful save clears the dirty state — otherwise the
// `window.onbeforeunload` handler stays attached and the browser pops the
// system reload dialog even though the project is clean.

let savedSnapshot: string | null = null
const subscribers = new Set<() => void>()

const notify = () => {
  for (const cb of subscribers) cb()
}

export const setSavedSnapshot = (json: string) => {
  savedSnapshot = json
  notify()
}

export const getSavedSnapshot = (): string | null => savedSnapshot

export const clearSavedSnapshot = () => {
  savedSnapshot = null
  notify()
}

export const subscribeSavedSnapshot = (cb: () => void): (() => void) => {
  subscribers.add(cb)
  return () => {
    subscribers.delete(cb)
  }
}
